import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, CardHeader, Row, Col, CardGroup, Buton } from "reactstrap";

import Widget04 from "./Widget04";
import PropTypes from "prop-types";
import Realisasi from "./Realisasi";
import WaktuTempuh from "./WaktuTempuh";
import LatestBarang from "./LatestBarang";
import OrderPerBulan from "./OrderPerBulan";
import VoyagePerTrayek from "./VoyagePerTrayek";
import DisparitasHarga from "./DisparitasHarga";
import SisaQuotaTrayek from "./SisaQuotaTrayek";
import MuatanTerbanyak from "./MuatanTerbanyak";
import LatestCommodity from "./LatestCommodity";
import MuatanPerWilayah from "./MuatanPerWilayah";
import OperatorName from "./Operator/OperatorName";
import ContainerPerTahun from "./ContainerPerTahun";
import MuatanPerOperator from "./MuatanPerOperator";
import LatestJadwalKapal from "./LatestJadwalKapal";
import LatestPurchaseOrder from "./LatestPurchaseOrder";
import LatestVesselBooking from "./LatestVesselBooking";
import VesselTracking from "./VesselTracking/VesselTracking";
import OrderPerJenisPrioritas from "./OrderPerJenisPrioritas";
import LatestDistribusiBarang from "./LatestDistribusiBarang";
import DashboardSisaQuotaTrayek from "./DashboardSisaQuotaTrayek";
import MuatanPerWilayahPerPrioritas from "./MuatanPerWilayahPerPrioritas";
import TopConsignee from "./TopConsignee";

import {
  consigneeStatisticAll,
  consigneeStatisticActive,
  supplierStatisticAll,
  supplierStatisticActive,
  shipperStatisticAll,
  shipperStatisticActive,
  resellerStatisticAll,
  resellerStatisticActive,
  operatorStatisticAll,
  operatorStatisticActive,
  regulatorStatisticAll,
  regulatorStatisticActive,
  allOrder,
  orderPaid,
  orderUnpaid,
  orderDenied,
  consigneeBerangkatAll,
  consigneeBalikAll,
  consigneeBerangkatActive,
  consigneeBalikActive,
  allOrderBerangkat,
  orderUnpaidBerangkat,
  orderDeniedBerangkat,
  orderPaidBerangkat,
  allOrderBalik,
  orderPaidBalik,
  orderUnpaidBalik,
  orderDeniedBalik,
} from "actions/dashboardAction";

import {
  USER_CAN_VIEW_VESSEL_TRACKING,
  USER_CAN_VIEW_REGISTERED_USER,
  USER_CAN_VIEW_TOTAL_ORDER,
  USER_CAN_VIEW_ORDER_THIS_MONTH,
  USER_CAN_VIEW_OPERATOR_LIST,
  USER_CAN_VIEW_TOTAL_REALISASI,
  USER_CAN_VIEW_DISPARITAS_HARGA,
  USER_CAN_VIEW_SISA_KUOTA,
  USER_CAN_VIEW_TOTAL_MUATAN,
  USER_CAN_VIEW_REALISASI_VOYAGE,
  USER_CAN_VIEW_WAKTU_TEMPUH,
  USER_CAN_VIEW_TOTAL_ORDER_PER_PRIORITAS,
  USER_CAN_VIEW_5_JENIS_MUATAN_PER_PRIORITAS,
  USER_CAN_VIEW_VOYAGE_PER_TRAYEK,
  USER_CAN_VIEW_TOTAL_CONTAINER_PER_PORT,
  USER_CAN_VIEW_LATEST_PO,
  USER_CAN_VIEW_LATEST_DISTRIBUSI_BARANG,
  USER_CAN_VIEW_LATEST_JADWAL_KAPAL,
  USER_CAN_VIEW_LATEST_KOMODITAS,
  USER_CAN_VIEW_LATEST_VESSEL_BOOKING,
  USER_CAN_VIEW_LATEST_BARANG,
  USER_CAN_VIEW_SISA_QUOTA_TRAYEK,
} from "acl";

import ConsigneeModalFalse from "./ConsigneeTypeFalseModals";
import ads from "../../assets/img/KREDIT-DINAMIS-470x470.jpg";
import adsBottom from "../../assets/img/KREDIT-DINAMIS-940x94.jpg";
import adsTemas from "../../assets/img/iklan-temas.jpg";
import "../../dashboard.css";
import DashboardTrendContainer from "./DashboardTrendContainer/index";
import { BASE_URL } from "actions/constant";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ads: true,
      adsZoom: false,
      adsBottom: true,
    };
  }

  componentDidMount() {
    // this.props.consigneeStatisticAll();
    // this.props.consigneeStatisticActive();
    this.props.consigneeBerangkatAllFetch();
    this.props.consigneeBalikAllFetch();
    this.props.consigneeBerangkatActiveFetch();
    this.props.consigneeBalikActiveFetch();
    this.props.supplierStatisticAll();
    this.props.supplierStatisticActive();
    this.props.shipperStatisticAll();
    this.props.shipperStatisticActive();
    this.props.resellerStatisticAll();
    this.props.resellerStatisticActive();
    this.props.operatorStatisticAll();
    this.props.operatorStatisticActive();
    this.props.regulatorStatisticAll();
    this.props.regulatorStatisticActive();
    this.props.allOrder();
    this.props.orderPaid();
    this.props.orderUnpaid();
    this.props.orderDenied();

    this.props.allOrderBerangkat();
    this.props.orderPaidBerangkat();
    this.props.orderUnpaidBerangkat();
    this.props.orderDeniedBerangkat();

    this.props.allOrderBalik();
    this.props.orderPaidBalik();
    this.props.orderUnpaidBalik();
    this.props.orderDeniedBalik();

    this.cekApprovalDoc();
  }

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
      let separator = sisa ? "." : "";
      rupiah += separator + ribuan.join(".");
    }

    return rupiah;
  }

  handleCloseAds() {
    this.setState({ ads: false });
  }

  handleCloseAdsBottom() {
    this.setState({ adsBottom: false });
  }

  handleZoom() {
    this.setState({ adsZoom: true });
  }

  handleZoomOut() {
    this.setState({ adsZoom: false });
  }

  cekApprovalDoc = async () => {
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await fetch(BASE_URL + "status-doc", config);
      if (!res.ok) {
        throw Error(res.statusText);
      }
      const resJson = await res.json();

      if (resJson.status === 200) {
        localStorage.setItem("status_approval_doc", resJson.data);
      }
    } catch (err) {
      window.alert("Error Connection");
    }
  };

  render() {
    // console.log("STATE ===>>> ", this.state);
    // console.log("PROPS ===>>> ", this.props);

    return (
      <div className="animated fadeIn">
        {/* {localStorage.getItem("tolaut@typeUser") === "1" && (
          <ConsigneeModalFalse />
        )} */}

        <Row>
          {localStorage.getItem(USER_CAN_VIEW_VESSEL_TRACKING) && (
            <Col xs="12" lg="12">
              <VesselTracking />
            </Col>
          )}
        </Row>

        <DashboardTrendContainer />

        {/* <div
          className={`ads ${this.state.ads ? "open-ads" : "close-ads"} ${
            this.state.adsZoom && " ads-zoom"
          }`}
        >
          <div className="ads-photo">
            <img src={ads} alt="" />
            <div className="icon-zoom-out">
              <i
                className="fa fa-times-circle-o"
                onClick={() => this.handleZoomOut()}
              ></i>
            </div>
          </div>
          <i className="fa fa-times" onClick={() => this.handleCloseAds()}></i>
          <div className="icon-zoom" onClick={() => this.handleZoom()}>
            <i className="fa fa-search-plus"></i>
          </div>
        </div>
        <div
          className={`ads-bottom`}
          style={!this.state.adsBottom ? { display: "none" } : {}}
        >
          <div className="ads-photo-bottom">
            <img src={adsBottom} />
          </div>
          <i
            className="fa fa-times"
            onClick={() => this.handleCloseAdsBottom()}
          ></i>
        </div> */}
      </div>
    );
  }
}

Dashboard.propTypes = {
  consigneeAllIsSuccess: PropTypes.bool.isRequired,
  consigneeAllHasError: PropTypes.bool.isRequired,
  consigneeAllIsLoading: PropTypes.bool.isRequired,

  consigneeActiveIsSuccess: PropTypes.bool.isRequired,
  consigneeActiveHasError: PropTypes.bool.isRequired,
  consigneeActiveIsLoading: PropTypes.bool.isRequired,

  supplierAllIsSuccess: PropTypes.bool.isRequired,
  supplierAllHasError: PropTypes.bool.isRequired,
  supplierAllIsLoading: PropTypes.bool.isRequired,

  supplierActiveIsSuccess: PropTypes.bool.isRequired,
  supplierActiveHasError: PropTypes.bool.isRequired,
  supplierActiveIsLoading: PropTypes.bool.isRequired,

  shipperAllIsSuccess: PropTypes.bool.isRequired,
  shipperAllHasError: PropTypes.bool.isRequired,
  shipperAllIsLoading: PropTypes.bool.isRequired,

  shipperActiveIsSuccess: PropTypes.bool.isRequired,
  shipperActiveHasError: PropTypes.bool.isRequired,
  shipperActiveIsLoading: PropTypes.bool.isRequired,

  resellerAllIsSuccess: PropTypes.bool.isRequired,
  resellerAllHasError: PropTypes.bool.isRequired,
  resellerAllIsLoading: PropTypes.bool.isRequired,

  resellerActiveIsSuccess: PropTypes.bool.isRequired,
  resellerActiveHasError: PropTypes.bool.isRequired,
  resellerActiveIsLoading: PropTypes.bool.isRequired,

  operatorAllIsSuccess: PropTypes.bool.isRequired,
  operatorAllHasError: PropTypes.bool.isRequired,
  operatorAllIsLoading: PropTypes.bool.isRequired,

  operatorActiveIsSuccess: PropTypes.bool.isRequired,
  operatorActiveHasError: PropTypes.bool.isRequired,
  operatorActiveIsLoading: PropTypes.bool.isRequired,

  regulatorAllIsSuccess: PropTypes.bool.isRequired,
  regulatorAllHasError: PropTypes.bool.isRequired,
  regulatorAllIsLoading: PropTypes.bool.isRequired,

  regulatorActiveIsSuccess: PropTypes.bool.isRequired,
  regulatorActiveHasError: PropTypes.bool.isRequired,
  regulatorActiveIsLoading: PropTypes.bool.isRequired,

  allOrderIsSuccess: PropTypes.bool.isRequired,
  allOrderHasError: PropTypes.bool.isRequired,
  allOrderIsLoading: PropTypes.bool.isRequired,

  orderPaidIsSuccess: PropTypes.bool.isRequired,
  orderPaidHasError: PropTypes.bool.isRequired,
  orderPaidIsLoading: PropTypes.bool.isRequired,

  orderUnpaidIsSuccess: PropTypes.bool.isRequired,
  orderUnpaidHasError: PropTypes.bool.isRequired,
  orderUnpaidIsLoading: PropTypes.bool.isRequired,

  orderDeniedIsSuccess: PropTypes.bool.isRequired,
  orderDeniedHasError: PropTypes.bool.isRequired,
  orderDeniedIsLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    consigneeBerangkatAll: state.dashboard.consigneeBerangkatAll,
    consigneeBerangkatAllIsSuccess:
      state.dashboard.consigneeBerangkatAllSuccess,
    consigneeBerangkatAllHasError: state.dashboard.consigneeBerangkatAllError,
    consigneeBerangkatAllIsLoading:
      state.dashboard.consigneeBerangkatAllLoading,

    consigneeBalikAll: state.dashboard.consigneeBalikAll,
    consigneeBalikAllIsSuccess: state.dashboard.consigneeBalikAllSuccess,
    consigneeBalikAllHasError: state.dashboard.consigneeBalikAllError,
    consigneeBalikAllIsLoading: state.dashboard.consigneeBalikAllLoading,

    consigneeAll: state.dashboard.consigneeAll,
    consigneeAllIsSuccess: state.dashboard.consigneeSttcAllSuccess,
    consigneeAllHasError: state.dashboard.consigneeSttcAllError,
    consigneeAllIsLoading: state.dashboard.consigneeSttcAllLoading,

    consigneeBerangkatActive: state.dashboard.consigneeBerangkatActive,
    consigneeBerangkatActiveIsSuccess:
      state.dashboard.consigneeBerangkatActiveSuccess,
    consigneeBerangkatActiveHasError:
      state.dashboard.consigneeBerangkatActiveError,
    consigneeBerangkatActiveIsLoading:
      state.dashboard.consigneeBerangkatActiveLoading,

    consigneeBalikActive: state.dashboard.consigneeBalikActive,
    consigneeBalikActiveIsSuccess: state.dashboard.consigneeBalikActiveSuccess,
    consigneeBalikActiveHasError: state.dashboard.consigneeBalikActiveError,
    consigneeBalikActiveIsLoading: state.dashboard.consigneeBalikActiveLoading,

    consigneeActive: state.dashboard.consigneeActive,
    consigneeActiveIsSuccess: state.dashboard.consigneeSttcActiveSuccess,
    consigneeActiveHasError: state.dashboard.consigneeSttcActiveError,
    consigneeActiveIsLoading: state.dashboard.consigneeSttcActiveLoading,

    supplierAll: state.dashboard.supplierAll,
    supplierAllIsSuccess: state.dashboard.supplierSttcAllSuccess,
    supplierAllHasError: state.dashboard.supplierSttcAllError,
    supplierAllIsLoading: state.dashboard.supplierSttcAllLoading,

    supplierActive: state.dashboard.supplierActive,
    supplierActiveIsSuccess: state.dashboard.supplierSttcActiveSuccess,
    supplierActiveHasError: state.dashboard.supplierSttcActiveError,
    supplierActiveIsLoading: state.dashboard.supplierSttcActiveLoading,

    shipperAll: state.dashboard.shipperAll,
    shipperAllIsSuccess: state.dashboard.shipperSttcAllSuccess,
    shipperAllHasError: state.dashboard.shipperSttcAllError,
    shipperAllIsLoading: state.dashboard.shipperSttcAllLoading,

    shipperActive: state.dashboard.shipperActive,
    shipperActiveIsSuccess: state.dashboard.shipperSttcActiveSuccess,
    shipperActiveHasError: state.dashboard.shipperSttcActiveError,
    shipperActiveIsLoading: state.dashboard.shipperSttcActiveLoading,

    resellerAll: state.dashboard.resellerAll,
    resellerAllIsSuccess: state.dashboard.resellerSttcAllSuccess,
    resellerAllHasError: state.dashboard.resellerSttcAllError,
    resellerAllIsLoading: state.dashboard.resellerSttcAllLoading,

    resellerActive: state.dashboard.resellerActive,
    resellerActiveIsSuccess: state.dashboard.resellerSttcActiveSuccess,
    resellerActiveHasError: state.dashboard.resellerSttcActiveError,
    resellerActiveIsLoading: state.dashboard.resellerSttcActiveLoading,

    operatorAll: state.dashboard.operatorAll,
    operatorAllIsSuccess: state.dashboard.operatorSttcAllSuccess,
    operatorAllHasError: state.dashboard.operatorSttcAllError,
    operatorAllIsLoading: state.dashboard.operatorSttcAllLoading,

    operatorActive: state.dashboard.operatorActive,
    operatorActiveIsSuccess: state.dashboard.operatorSttcActiveSuccess,
    operatorActiveHasError: state.dashboard.operatorSttcActiveError,
    operatorActiveIsLoading: state.dashboard.operatorSttcActiveLoading,

    regulatorAll: state.dashboard.regulatorAll,
    regulatorAllIsSuccess: state.dashboard.regulatorSttcAllSuccess,
    regulatorAllHasError: state.dashboard.regulatorSttcAllError,
    regulatorAllIsLoading: state.dashboard.regulatorSttcAllLoading,

    regulatorActive: state.dashboard.regulatorActive,
    regulatorActiveIsSuccess: state.dashboard.regulatorSttcActiveSuccess,
    regulatorActiveHasError: state.dashboard.regulatorSttcActiveError,
    regulatorActiveIsLoading: state.dashboard.regulatorSttcActiveLoading,

    allOrderData: state.dashboard.allOrderData,
    allOrderIsSuccess: state.dashboard.allOrderSuccess,
    allOrderHasError: state.dashboard.allOrderError,
    allOrderIsLoading: state.dashboard.allOrderLoading,

    orderPaidData: state.dashboard.orderPaidData,
    orderPaidIsSuccess: state.dashboard.orderPaidSuccess,
    orderPaidHasError: state.dashboard.orderPaidError,
    orderPaidIsLoading: state.dashboard.orderPaidLoading,

    orderUnpaidData: state.dashboard.orderUnpaidData,
    orderUnpaidIsSuccess: state.dashboard.orderUnpaidSuccess,
    orderUnpaidHasError: state.dashboard.orderUnpaidError,
    orderUnpaidIsLoading: state.dashboard.orderUnpaidLoading,

    orderDeniedData: state.dashboard.orderDeniedData,
    orderDeniedIsSuccess: state.dashboard.orderDeniedSuccess,
    orderDeniedHasError: state.dashboard.orderDeniedError,
    orderDeniedIsLoading: state.dashboard.orderDeniedLoading,

    allOrderBerangkatData: state.dashboard.allOrderBerangkatData,
    allOrderBerangkatIsSuccess: state.dashboard.allOrderBerangkatSuccess,
    allOrderBerangkatHasError: state.dashboard.allOrderBerangkatError,
    allOrderBerangkatIsLoading: state.dashboard.allOrderBerangkatLoading,

    orderPaidBerangkatData: state.dashboard.orderPaidBerangkatData,
    orderPaidBerangkatIsSuccess: state.dashboard.orderPaidBerangkatSuccess,
    orderPaidBerangkatHasError: state.dashboard.orderPaidBerangkatError,
    orderPaidBerangkatIsLoading: state.dashboard.orderPaidBerangkatLoading,

    orderUnpaidBerangkatData: state.dashboard.orderUnpaidBerangkatData,
    orderUnpaidBerangkatIsSuccess: state.dashboard.orderUnpaidBerangkatSuccess,
    orderUnpaidBerangkatHasError: state.dashboard.orderUnpaidBerangkatError,
    orderUnpaidBerangkatIsLoading: state.dashboard.orderUnpaidBerangkatLoading,

    orderDeniedBerangkatData: state.dashboard.orderDeniedBerangkatData,
    orderDeniedBerangkatIsSuccess: state.dashboard.orderDeniedBerangkatSuccess,
    orderDeniedBerangkatHasError: state.dashboard.orderDeniedBerangkatError,
    orderDeniedBerangkatIsLoading: state.dashboard.orderDeniedBerangkatLoading,

    allOrderBalikData: state.dashboard.allOrderBalikData,
    allOrderBalikIsSuccess: state.dashboard.allOrderBalikSuccess,
    allOrderBalikHasError: state.dashboard.allOrderBalikError,
    allOrderBalikIsLoading: state.dashboard.allOrderBalikLoading,

    orderPaidBalikData: state.dashboard.orderPaidBalikData,
    orderPaidBalikIsSuccess: state.dashboard.orderPaidBalikSuccess,
    orderPaidBalikHasError: state.dashboard.orderPaidBalikError,
    orderPaidBalikIsLoading: state.dashboard.orderPaidBalikLoading,

    orderUnpaidBalikData: state.dashboard.orderUnpaidBalikData,
    orderUnpaidBalikIsSuccess: state.dashboard.orderUnpaidBalikSuccess,
    orderUnpaidBalikHasError: state.dashboard.orderUnpaidBalikError,
    orderUnpaidBalikIsLoading: state.dashboard.orderUnpaidBalikLoading,

    orderDeniedBalikData: state.dashboard.orderDeniedBalikData,
    orderDeniedBalikIsSuccess: state.dashboard.orderDeniedBalikSuccess,
    orderDeniedBalikHasError: state.dashboard.orderDeniedBalikError,
    orderDeniedBalikIsLoading: state.dashboard.orderDeniedBalikLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    consigneeBerangkatAllFetch: () => dispatch(consigneeBerangkatAll()),
    consigneeBalikAllFetch: () => dispatch(consigneeBalikAll()),
    consigneeStatisticAll: () => dispatch(consigneeStatisticAll()),
    consigneeBerangkatActiveFetch: () => dispatch(consigneeBerangkatActive()),
    consigneeBalikActiveFetch: () => dispatch(consigneeBalikActive()),
    consigneeStatisticActive: () => dispatch(consigneeStatisticActive()),
    supplierStatisticAll: () => dispatch(supplierStatisticAll()),
    supplierStatisticActive: () => dispatch(supplierStatisticActive()),
    shipperStatisticAll: () => dispatch(shipperStatisticAll()),
    shipperStatisticActive: () => dispatch(shipperStatisticActive()),
    resellerStatisticAll: () => dispatch(resellerStatisticAll()),
    resellerStatisticActive: () => dispatch(resellerStatisticActive()),
    operatorStatisticAll: () => dispatch(operatorStatisticAll()),
    operatorStatisticActive: () => dispatch(operatorStatisticActive()),
    regulatorStatisticAll: () => dispatch(regulatorStatisticAll()),
    regulatorStatisticActive: () => dispatch(regulatorStatisticActive()),
    allOrder: () => dispatch(allOrder()),
    orderPaid: () => dispatch(orderPaid()),
    orderUnpaid: () => dispatch(orderUnpaid()),
    orderDenied: () => dispatch(orderDenied()),

    allOrderBerangkat: () => dispatch(allOrderBerangkat()),
    orderPaidBerangkat: () => dispatch(orderPaidBerangkat()),
    orderUnpaidBerangkat: () => dispatch(orderUnpaidBerangkat()),
    orderDeniedBerangkat: () => dispatch(orderDeniedBerangkat()),

    allOrderBalik: () => dispatch(allOrderBalik()),
    orderPaidBalik: () => dispatch(orderPaidBalik()),
    orderUnpaidBalik: () => dispatch(orderUnpaidBalik()),
    orderDeniedBalik: () => dispatch(orderDeniedBalik()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
